import { useMemo, useState } from "react";

import { useGetEvent } from "../../api/event";
import ChartTimeFrameControl from "./ChartTimeFrameControl";
import { resolveChartRange } from "./timeFrame";

// Bundles the per-chart time frame boilerplate: the event lookup (deduped by
// React Query), the local range state, the memoized resolved [from, to] used to
// slice data, and the ready-to-render control. Call it once per independent
// range — sibling charts that share a range read the same `resolved`/`control`.
export const useChartTimeFrame = (
  eventId,
  { default: defaultTimeFrame = "event" } = {}
) => {
  const { data: event } = useGetEvent(eventId);
  const [range, setRange] = useState({ timeFrame: defaultTimeFrame });

  const resolved = useMemo(
    () => resolveChartRange(range, event),
    [range, event]
  );

  const control = (
    <ChartTimeFrameControl value={range} onChange={setRange} event={event} />
  );

  return { range, resolved, control };
};
